import TimePicker from './src/time-picker.vue';
import CommonPicker from './src/common/picker.vue';
import CommonPickerV2 from './src/common/picker-v2.vue';
import TimePickPanel from './src/time-picker-com/panel-time-pick.vue';
export * from './src/common/date-utils';
export * from './src/common/constant';
export * from './src/common/props';

TimePicker.install = (app) => {
    app.component(TimePicker.name, TimePicker);
};

export { CommonPicker, CommonPickerV2, TimePickPanel };
export default TimePicker;

declare module 'vue' {
    export interface GlobalComponents {
        PtTimePicker: typeof TimePicker;
    }
}
